import { AfterViewInit, ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { CustomSnackComponents } from '.';
import { SnackbarDirective } from '../snackbar-ref.directive';

@Component({
  selector: 'ui-snackbar-templates',
  templateUrl: './snackbar-templates.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SnackbarTemplatesComponent implements AfterViewInit {
  @Input() template: keyof typeof CustomSnackComponents = 'test';

  @ViewChild(SnackbarDirective) uiSnackbarRef: SnackbarDirective;

  components = CustomSnackComponents;

  constructor() {}

  ngAfterViewInit(): void {
    const component: any = this.components[this.template];
    this.uiSnackbarRef.containerRef.createComponent(component);
  }
}
